import { render, staticRenderFns } from "./StatisticsRental.vue?vue&type=template&id=160779fc&scoped=true&"
import script from "./StatisticsRental.vue?vue&type=script&lang=ts&"
export * from "./StatisticsRental.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160779fc",
  null
  
)

export default component.exports